import { render } from "./Logos.vue?vue&type=template&id=48ee18d8&scoped=true&ts=true"
import script from "./Logos.vue?vue&type=script&lang=ts"
export * from "./Logos.vue?vue&type=script&lang=ts"

import "./Logos.vue?vue&type=style&index=0&id=48ee18d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ee18d8"]])

export default __exports__